import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = ['row', 'progress', 'meter']
  static values = { mode: String }

  connect() {
    this.refresh()
    this.initialValues = this.valuesSignature()
    this.form = this.element.closest('form')
    this.onSubmit = () => { this.submitting = true }
    this.onSubmitEnd = event => { if (!event.detail.success) this.submitting = false }
    this.warnBeforeLeave = event => {
      if (!this.submitting && this.initialValues !== this.valuesSignature()) {
        event.preventDefault()
        event.returnValue = ''
      }
    }
    this.confirmNavigation = event => {
      if (!this.submitting && this.initialValues !== this.valuesSignature() && !window.confirm('Leave this task? Your unsubmitted entries will be lost.')) event.preventDefault()
    }
    this.form.addEventListener('submit', this.onSubmit)
    this.form.addEventListener('turbo:submit-end', this.onSubmitEnd)
    window.addEventListener('beforeunload', this.warnBeforeLeave)
    document.addEventListener('turbo:before-visit', this.confirmNavigation)
  }

  disconnect() {
    this.form.removeEventListener('submit', this.onSubmit)
    this.form.removeEventListener('turbo:submit-end', this.onSubmitEnd)
    window.removeEventListener('beforeunload', this.warnBeforeLeave)
    document.removeEventListener('turbo:before-visit', this.confirmNavigation)
  }

  valuesSignature() {
    return JSON.stringify(Array.from(this.element.querySelectorAll('[data-choice], [data-detail], [data-attachment]')).map(field => field.type === 'radio' ? field.checked : field.value))
  }

  refresh() {
    let complete = 0
    this.rowTargets.forEach(row => {
      if (this.modeValue === 'checklist') {
        const checked = row.querySelector('[data-step]').checked
        row.querySelector('[data-choice]').value = checked ? 'done' : 'skipped'
        row.classList.toggle('is-done', checked)
        if (checked) complete++
      } else {
        const choice = row.querySelector('[data-choice]:checked')?.value
        const detail = row.querySelector('[data-detail]')
        detail.placeholder = choice === 'missing' ? 'What is missing, and what happens next?' : 'Add a reference or attach the file'
        if (choice && detail.value.trim()) complete++
      }
    })
    const total = this.rowTargets.length
    const noun = this.modeValue === 'checklist' ? 'done' : 'recorded'
    this.progressTarget.textContent = complete === total && total > 1 ? `${total === 2 ? 'Both' : `All ${total}`} ${noun}` : `${complete} of ${total} ${noun}`
    this.meterTarget.style.width = `${complete / total * 100}%`
    this.element.dataset.complete = complete === total
  }

  async upload(event) {
    const input = event.target
    const file = input.files[0]
    if (!file) return
    const row = input.closest('[data-simple-collection-target="row"]')
    const status = row.querySelector('[data-upload-status]')
    const form = this.element.closest('form')
    const blockSubmit = event => { event.preventDefault(); event.stopImmediatePropagation() }
    form.addEventListener('submit', blockSubmit, true)
    input.disabled = true
    status.textContent = 'Uploading…'
    const body = new FormData()
    body.append('file', file)
    try {
      const response = await fetch(input.dataset.url, { method: 'POST', body, headers: { Accept: 'application/json', 'X-CSRF-Token': document.querySelector('meta[name="csrf-token"]')?.content || '' } })
      const data = await response.json()
      if (!response.ok) throw new Error(data.error || 'Upload failed. Try again.')
      const detail = row.querySelector('[data-detail]')
      row.querySelector('[data-attachment]').value = data.id
      if (!detail.value.trim()) detail.value = data.filename
      const received = row.querySelector('[data-choice][value="received"]')
      if (received) received.checked = true
      status.textContent = `Attached: ${data.filename}`
      this.refresh()
    } catch (error) {
      status.textContent = error.message
    } finally {
      input.disabled = false
      input.value = ''
      form.removeEventListener('submit', blockSubmit, true)
    }
  }
}
